import { ExMutationTree } from "vuex";
import { State, Mutations } from "./types";

const mutations: ExMutationTree<State, Mutations> = {
  setHasScoutCanNotSendError(state) {
    state.hasScoutCanNotSendError = true;
  },
  clearHasScoutCanNotSendError(state) {
    state.hasScoutCanNotSendError = false;
  }
};

export default mutations;
